import { fetchAndParse, CheckStatus } from '../utils/ajax';
import { getAuthFromWindow, getErrorMessage } from '../utils/auth';
import { isNullOrEmpty } from '../utils/guard';
import { getTenantId } from '../utils/tenant';

export const signOut = async () => {
    await fetch('/api/draw/1/authentication/signout', {
        method: 'POST',
    }).then(CheckStatus);
};

export const signOutSSO = async () => {
    const response = await fetchAndParse<{ redirectUri: string | null }>({
        url: '/api/draw/1/authentication/saml/signout',
        method: 'POST',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });

    return response;
};

export const signOutUser = async (isSso: boolean) => {
    let uri = '/logged-out';
    if (isSso) {
        const { redirectUri } = await signOutSSO();
        if (!isNullOrEmpty(redirectUri)) {
            uri = redirectUri;
        }
    } else {
        try {
            await getAuthFromWindow()?.logout();
        } catch (err) {
            console.error(getErrorMessage(err));
        }
        await cookieStore.delete('ACCOUNT_ID');
    }
    window.location.assign(uri);
};
